import React from 'react';
import {theme} from '../../Theme';
import PrimaryButton from './PrimaryButton';

export default function SecondaryButton(props: $TSFixMe) {
  return (
    <PrimaryButton
      {...props}
      color="transparent"
      textColor={theme.palette.primary.light}
      style={{
        ...props.style,
        border: '1px solid #0000008f',
      }}>
      {props.children}
    </PrimaryButton>
  );
}
